// Module
var code = "<div class=\"loan-redirect\"> <preloader-dot preloader-size=\"lg\" preloader-text=\"'Redirecting loan'\"></preloader-dot> </div> ";
// Exports
module.exports = code;